import IndexPage from '../index-table/IndexPage';
import * as React from 'react';
import APIServicesRegistry from "../../api-services/APIServicesRegistry";
import ProjectsTable from "../projects/ProjectsTable";
import TWSProjectAPIService from '@lib/api-services/TWSProjectApiService';
import TWSProjectsAPIService from '@lib/api-services/TWSProjectsApiService';

interface SelfProps {
    columns: any[],
    filter: any,
    options: any,
    orderOptions: any[],
    paging: any,
    results: any[],
    tableLoadingOrder: boolean
}
export class TwsProjectIndexPage extends IndexPage {

    editApiService: any;

    addCalculation = () => {
        window.location.href = "TWSCalculation/Create";
    }
    constructor(props: SelfProps) {
        super(props);
        this.state = {
            ...this.state,
            filterData: {
                filter: {
                    show: false
                }
            }
        };
        console.warn(props)
    }

    atDocumentReady = () => {
        this.indexApiService = APIServicesRegistry.getService(TWSProjectsAPIService);
        this.editApiService = APIServicesRegistry.getService(TWSProjectAPIService);

        if (this._isMounted) {
            this.setState({ renderTrigger: Math.random() })
        }
    }

    onRemoveClick() {
        let ids: any[] = []
        for (let [k, v] of Object.entries(this.state.manuallyChangedRows)) {
            if (v) {
                ids.push(parseInt(k))
            }
        }

        this.setState({ isLoading: true })
        this.editApiService.deleteBatch(ids).then(() => {
            let filtered = this.state.results.filter((x: any) => !ids.includes(x.id))
            this.setState({
                results: filtered,
                deleteModalIsOpen: false,
                isLoading: false
            })
        })
    }

    renderTitle = () => {
        return (
            <React.Fragment>
                <h3 className="page-body-title">{__('Projects')}</h3>
                <div className="page-body-title-separator"></div>
            </React.Fragment>
        )
    }

    renderTable = () => {
        const commonProps = {
            results: this.state.results,
            options: this.props.options,
            orderOptions: this.props.orderOptions,
            onSortChange: this.onSortChange,
            onRemoveRowClick: this.onRemoveRowClick,
            onRootCheckboxToggled: this.onRootCheckboxToggled,
            onRowCheckboxToggled: this.onRowCheckboxToggled,
            multiSelectRows: this.props.multiSelectRows,
            onReloadCall: this.onReloadCall
        };

        console.warn(commonProps, this.props.columns)

        return (
            <ProjectsTable
                {...commonProps}
                columns={this.props.columns}
            />
        );
    }
}

window.components.TwsProjectIndexPage = TwsProjectIndexPage;